<script>

    import { toast } from 'bulma-toast'

    import ZipcodesService from '../$services/zipcodes.service'
    import Spinner from '../$components/spinner.svelte'

    import InputText from '../$components/input.text.svelte'

    export let zipcode;
    export let state;
    export let city;
    export let municipality;
    export let colony;

    export let disabled = false;

    let colonies = []
    let loading = false
    let showInput = false

    if(zipcode && !colony)
        findZipcode()

    if(zipcode && colony)
        findZipcode(false)

    if(disabled && !zipcode)
        disabled = false

    async function findZipcode(deleteColony = true) {

        state = ''
        city = ''
        municipality = ''
        colony = deleteColony? '' : colony
        colonies = []

        if(zipcode.length != 5)
            return

        loading = true
        const resp = await ZipcodesService.getZipcodeColony(zipcode)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        if(!resp.data)
            return toast({message: 'No se encontro información del código postal', type: 'is-danger'})

        state = resp.data.state
        city = resp.data.city
        municipality = resp.data.municipality
        colonies = resp.data.colony || []

        if(colony) {
            const inColonies = colonies.find(item => item === colony)
            showInput = !inColonies
        }
    }

</script>

<Spinner {loading} />

{#if !loading}
    <div class="columns">
        <div class="column">
            <div class="field">
                <label for="" class="label">Código postal</label>
                <div class="control">
                    <input bind:value={zipcode} on:keyup={findZipcode} type="text" class="input" placeholder="Código postal" {disabled} required>
                </div>
            </div>
        </div>
        <div class="column">
            <InputText bind:value={state} label="Estado" placeholder="Estado" {disabled} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={city} label="Ciudad" placeholder="Ciudad" {disabled} />
        </div>
        <div class="column">
            <InputText bind:value={municipality} label="Municipio" placeholder="Municipio" {disabled} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <div class="field">
                <label for="" class="label is-flex is-justify-content-space-between is-align-items-center">
                    <div>Colonia</div>
                    {#if colonies.length}
                        <small>
                            <input bind:checked={showInput} type="checkbox">
                            <label for="">Otro</label>
                        </small>
                    {/if}
                </label>
                {#if colonies.length && !showInput}
                    <div class="control">
                        <div class="select">
                            <select bind:value={colony} required>
                                <option value="">Selecciona una colonia</option>
                                {#each colonies as colony}
                                    <option value="{colony}">{ colony }</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                {/if}
                {#if !colonies.length || showInput}
                    <div class="control">
                        <input bind:value={colony} type="text" class="input" placeholder="Colonia" required>
                    </div>
                {/if}
            </div>
        </div>
    </div>
{/if}